import React from "react";
import Dashboard from "./dashboard/Dashboard";
import Layout from "../layout/Layout";

interface HomeProps {
  onLogout: () => void;
}

const Home: React.FC<HomeProps> = ({ onLogout }) => {
  return (
    <Layout>
      {/* <Header onLogout={onLogout} /> */}
      <Dashboard onLogout={onLogout} />
    </Layout>
  );
};

export default Home;
